import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { ROUTES } from '../../constants/routes';

const GUARANTEES = [
//   'No prepayment required',
  '60-min Trustian arrival guaranteed',
  'Free cancellation until 2 hrs before',
];

const CTABand = () => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        bgcolor: 'var(--sage)',
        py: { xs: 7, md: 10 },
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Decorative circles */}
      <Box
        sx={{
          position: 'absolute',
          top: -120,
          left: -120,
          width: 380,
          height: 380,
          borderRadius: '50%',
          bgcolor: 'rgba(255,255,255,0.06)',
          pointerEvents: 'none',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: -120,
          right: -120,
          width: 380,
          height: 380,
          borderRadius: '50%',
          bgcolor: 'rgba(255,255,255,0.05)',
          pointerEvents: 'none',
        }}
      />

      <Container
        maxWidth="md"
        sx={{
          maxWidth: 820,
          px: { xs: 2, md: 4 },
          position: 'relative',
          zIndex: 2,
          textAlign: 'center',
        }}
      >
        {/* Eyebrow */}
        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 1.25,
            mb: 2,
            lineHeight: 1,
          }}
        >
          <Box sx={{ width: 24, height: '1.5px', bgcolor: 'rgba(255,255,255,0.5)' }} />
          <Typography
            component="span"
            sx={{
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: '0.22em',
              textTransform: 'uppercase',
              color: 'rgba(255,255,255,0.7)',
              lineHeight: 1,
            }}
          >
            Book Today
          </Typography>
        </Box>

        {/* Title */}
        <Typography
          className="serif"
          sx={{
            fontSize: { xs: 26, sm: 32, md: 40, lg: 46 },
            fontWeight: 500,
            color: '#fff',
            lineHeight: 1.15,
            mb: 2,
          }}
        >
          Your health intelligence
          <br />
          starts here.
        </Typography>

        {/* Subtitle */}
        <Typography
          sx={{
            fontSize: { xs: 13, md: 14 },
            color: 'rgba(255,255,255,0.7)',
            fontWeight: 400,
            mb: 1.25,
            lineHeight: 1.6,
          }}
        >
          Home collection · Reports in 6 hours · Doctor-verified · 13 cities across India
        </Typography>

        {/* Promo code line */}
        <Typography
          component="span"
          sx={{
            display: 'inline-block',
            fontSize: 13,
            color: 'rgba(255,255,255,0.6)',
            mb: 4,
            fontWeight: 400,
          }}
        >
          Use code{' '}
          <Box
            component="span"
            sx={{
              color: 'var(--amber)',
              fontWeight: 800,
              letterSpacing: '0.04em',
            }}
          >
            TRUST10
          </Box>{' '}
          for 10% off your first booking
        </Typography>

        {/* Buttons */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'center',
            gap: 1.75,
            mb: 3.5,
          }}
        >
          <Button
            onClick={() => navigate(ROUTES.TESTS)}
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 1,
              bgcolor: '#fff',
              color: 'var(--ink)',
              borderRadius: 100,
              fontSize: 14,
              fontWeight: 700,
              textTransform: 'none',
              px: 3,
              py: 1.25,
              '&:hover': {
                bgcolor: '#fff',
                transform: 'translateY(-2px)',
                boxShadow: '0 10px 24px rgba(0,0,0,0.15)',
              },
            }}
          >
            <CalendarMonthIcon sx={{ fontSize: 18, color: 'var(--forest)', display: 'block' }} />
            Book a Test Now
          </Button>

          <Button
            href="https://wa.me/+919014638633"
            target="_blank"
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 1,
              border: '1.5px solid rgba(255,255,255,0.35)',
              color: '#fff',
              borderRadius: 100,
              fontSize: 14,
              fontWeight: 700,
              textTransform: 'none',
              px: 3,
              py: 1.25,
              '&:hover': { borderColor: '#fff', bgcolor: 'rgba(255,255,255,0.08)' },
            }}
          >
            <WhatsAppIcon sx={{ fontSize: 18, display: 'block' }} />
            Chat on WhatsApp
          </Button>
        </Box>

        {/* Guarantees row */}
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
            gap: { xs: 1.5, md: 3 },
          }}
        >
          {GUARANTEES.map((g) => (
            <Box
              key={g}
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.75,
                lineHeight: 1,
              }}
            >
              <Box
                component="span"
                sx={{
                  fontSize: 12,
                  color: 'rgba(255,255,255,0.7)',
                  fontWeight: 700,
                  lineHeight: 1,
                }}
              >
                ✓
              </Box>
              <Typography
                component="span"
                sx={{
                  fontSize: 12,
                  color: 'rgba(255,255,255,0.7)',
                  fontWeight: 400,
                  lineHeight: 1,
                }}
              >
                {g}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default CTABand;
